import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'antd';
import Translate from 'react-translate-component';
import { withAsyncActions } from 'react-async-client';

import { postApplication } from 'actions/asyncActions';
import { modalPropTypes } from 'components/Modals';
import ApplicationForm from './ApplicationForm';

@withAsyncActions({
    postApplication: postApplication
        .withSuccessHandler(props => props.close())
        .withOptions({ autoReset: true })
})
export default class ApplicationCreateModal extends Component {
    static propTypes = {
        ...modalPropTypes,
        postApplication: PropTypes.object.isRequired,
    };

    render() {
        const { modal, postApplication, params: { id, name = null } } = this.props;

        const header = (
            <div>
                <Translate content="education.application.create"/> - {name}
            </div>
        );

        return (
            <Modal {...modal} title={header} footer={null}>
                <ApplicationForm
                    formAction={postApplication}
                    id={id}
                />
            </Modal>
        );
    }
}
